<template>
  <BaseButton
    v-bind="$attrs"
    v-on="$listeners"
    :styleConfig="styleConfig"
  >
    <slot />
  </BaseButton>
</template>

<script>
  import BaseButton from '@base/v2/base-button'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'ButtonAction',
    inheritAttrs: false,
    components: {
      BaseButton,
    },
    data: function () {
      return {
        styleConfig: {
          button: {
            fontFamily: FontStyle.family.primary,
            fontSize: FontStyle.size.md,
            fontWeight: FontStyle.weight.xl,
          },
          container: {
            borderRadius: Layout.space.md,
            borderWidth: '1px',
            cursor: {
              '': 'pointer',
              disabled: 'default',
            },
            height: '32px',
            padding: `${Layout.space.sm} ${Layout.space.md}`,
          },
          root: {},
        },
      };
    },
    created: function () {
      Object.assign(
        this.styleConfig.button,
        {
          color: {
            '': this.color.action1(),
            disabled: this.color.action1(0.25),
          },
        },
      );
      Object.assign(
        this.styleConfig.container,
        {
          backgroundColor: {
            '': this.color.light1(),
            active: this.color.action1(0.25),
            disabled: this.color.light1(),
            hover: this.color.action1(0.25),
          },
          border: {
            '': `solid ${this.color.action1()}`,
            disabled: `solid ${this.color.action1(0.25)}`,
          },
        },
      );
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
  };
</script>
